export default __webpack_public_path__ + "static/media/obs_step4.4017cbc6.png";